import React from 'react'

class LogoPm extends React.Component {
    render() {
        return (

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
                <g fill="none" fill-rule="evenodd">
                    <path fill="#C3D946" d="M332.62 132.935c-9.294-5.025-74.7 5.46-85.456 5.685-10.756.225-11.668-16.033-25.628-23.592-5.903-3.197-21.472-.123-38.25 4.773-20.343-11.79-73.633-41.195-75.72-27.01 0 0-14.317 3.826 12.356 51.637-3.764 2.73-8.042 6.243-12.52 10.305C-6.66 110.14 1.23 152.578 1.23 152.578c12.767 45.13 49.357 75.664 71.484 90.597 2.56 28.776 8.58 57.297 8.58 57.297 11.27 165.795 130.11 156.635 130.11 156.635 67.753-50.125 99.12-126.592 83.56-141.02-15.562-14.43-32.26-38.018-30.89-47.862 1.378-9.846 26.323-9.61 50.357-25.633 24.038-16.023 10.99-19.23 10.99-19.23-41.193 15.557-93.604 15.772-68.2 10.74 3.105-.613 6.57-1.588 10.257-2.82l-.003.003 1.085 3.09 5.594-5.502c1.682-.65 3.386-1.333 5.113-2.05l-1.833 5.94s8.03-5.155 12.315-10.54c.904-.42 1.806-.84 2.707-1.263-.593 3.494-1.817 8.607-1.817 8.607s11.55-9.022 13.76-14.46c9.955-5.05 18.57-9.822 23.37-12.54 2.64-1.49 4.574-3.97 5.43-6.88 13.867-47.18 8.435-57.88-.578-62.75"/>
                    <path fill="#FEFEFE" d="M217.203 172.968l-29.217-9.908-1.746 5.145 29.22 9.91"/>
                    <path fill="#FEFEFE" d="M209.47 156.567l-9.9 29.232-5.148-1.75 9.9-29.23"/>
                </g>
            </svg>

        );
    }
}

export default LogoPm



// WEBPACK FOOTER //
// ../components/SVG/LogoPm.jsx